import UploadSingleBatchUser from "./UploadSingleBatchUser";

export default UploadSingleBatchUser;



// WEBPACK FOOTER //
// ./src/features/score-card/pages/upload-single-batch-user/index.js